import { useState } from 'react';
import { downloadDocument } from '@/lib/documentDownloads';
import { apiErr } from '@/lib/api';
import { toast } from 'sonner';
import CompareDocumentLink from './CompareDocumentLink';

export default function ApplicationDocumentLinks({ documents, jobId, trailing, compact = false, compare = true }) {
  const [busy,setBusy]=useState(null);
  if (!documents?.resume_version_id && !documents?.cover_letter_version_id && !trailing) return null;
  documents = documents || {};
  const open=async(event,kind,id)=>{
    event.preventDefault();event.stopPropagation();setBusy(kind);
    try { await downloadDocument(`/${kind==='resume'?'resume':'cover-letter'}-versions/${id}/export?format=docx`); }
    catch(error){toast.error(apiErr(error));}finally{setBusy(null);}
  };
  return <div className={compact ? 'flex gap-1 items-center flex-nowrap [&>button]:min-w-0 [&>button]:px-1 [&>button]:text-[11px] [&>button]:whitespace-nowrap' : 'flex gap-2 flex-wrap mt-3'} data-testid={`document-links-${jobId}`}>
    {documents.resume_version_id && (
      <div className="inline-flex items-center rounded border border-border overflow-hidden">
        <button type="button" disabled={!!busy} onClick={(event)=>open(event,'resume',documents.resume_version_id)} data-testid={`resume-word-${jobId}`} className="px-2 py-1 text-xs text-primary hover:bg-primary/10" title="Download Word (.docx)">
          {busy==='resume'?'Opening…':'Résumé · Word'}
        </button>
        {compare && <CompareDocumentLink kind="resume" versionId={documents.resume_version_id} className="border-0 border-l border-border rounded-none h-auto py-1 px-1.5 hover:bg-primary/10" />}
      </div>
    )}
    {documents.cover_letter_version_id && (
      <div className="inline-flex items-center rounded border border-border overflow-hidden">
        <button type="button" disabled={!!busy} onClick={(event)=>open(event,'letter',documents.cover_letter_version_id)} data-testid={`letter-word-${jobId}`} className="px-2 py-1 text-xs text-primary hover:bg-primary/10" title="Download Word (.docx)">
          {busy==='letter'?'Opening…':'Cover letter · Word'}
        </button>
        {compare && <CompareDocumentLink kind="letter" versionId={documents.cover_letter_version_id} className="border-0 border-l border-border rounded-none h-auto py-1 px-1.5 hover:bg-primary/10" />}
      </div>
    )}
    {trailing}
  </div>;
}
